export const statusCode = {
  default: 'default',
  success: 'success',
  collectResult: 'collectResult', // collectResult for error case 1
  toastMsg: 'toastMsg', // toastMsg for error case 2, collectResult no value
  collected: 'collected', // received but not used
};

export interface ICountdown {
  prefixText: string;
  todayEndTS: number;
  endTS: number;
  countdownDay: number;
  dayText: string;
}

export interface IUserTrack {
  spmd?: string;
  exposeArgs?: object;
  trackingParam?: object;
  clickArgs?: object;
  spmc?: string;
}